<script setup>
const { isDark, bodyDark, arcoDark } = useSite()

useHead2(() => ({
  htmlAttrs: {
    class: [bodyDark.value],
  },
  bodyAttrs: {
    class: ['bg-white dark:bg-black dark:text-white'],
    ...arcoDark.value,
  },
}))
</script>

<template lang="pug">
div
  WebHeader
  slot
  WebFooter
</template>
